var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMerchandising(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42.684px",
    height: "59.82px",
    viewBox: "0 0 42.684 59.82",
    enableBackground: "new 0 0 42.684 59.82",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 42.684,
    height: 59.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M1.645,16.112C0.736,16.112,0,16.849,0,17.757v31.226C0,54.959,4.861,59.82,10.836,59.82h21.01 c5.976,0,10.838-4.861,10.838-10.837V17.757c0-0.908-0.739-1.645-1.645-1.645h-8.205v-4.619C32.834,5.155,27.68,0,21.342,0 S9.848,5.155,9.848,11.493v4.619H1.645z M31.846,56.531h-21.01c-4.162,0-7.547-3.386-7.547-7.548V19.401h6.559v11.651 c0,0.908,0.738,1.645,1.644,1.645c0.908,0,1.645-0.737,1.645-1.645V19.401h16.408v11.651c0,0.908,0.738,1.645,1.645,1.645 c0.908,0,1.644-0.737,1.644-1.645V19.401h6.561v29.582C39.395,53.145,36.008,56.531,31.846,56.531 M29.545,16.112H13.137v-4.619 c0-4.524,3.681-8.204,8.205-8.204c4.523,0,8.203,3.68,8.203,8.204V16.112z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerchandising);
export default __webpack_public_path__ + "static/media/icon-merchandising.2f5147d6e7df742d7badfc1f0b393a43.svg";
export { ForwardRef as ReactComponent };